// DividerBlockEditor — section separator, with style switch.

import type { DividerBlock, Block } from "../../../lib/blocks";
import { t } from "../theme";

export interface DividerBlockEditorProps {
  block: DividerBlock;
  onChange: (patch: Partial<Block>) => void;
  isSelected: boolean;
}

const STYLES: { value: DividerBlock["style"]; label: string }[] = [
  { value: "line", label: "Line" },
  { value: "dots", label: "Dots" },
  { value: "asterisks", label: "Asterisks" },
  { value: "blank", label: "Blank" },
];

export function DividerBlockEditor({
  block,
  onChange,
  isSelected,
}: DividerBlockEditorProps) {
  return (
    <div>
      {isSelected && (
        <div style={{ display: "flex", gap: 6, marginBottom: 8, fontFamily: t.sans }}>
          {STYLES.map((s) => (
            <button
              key={s.value}
              type="button"
              onClick={() => onChange({ style: s.value } as Partial<DividerBlock>)}
              style={{
                padding: "3px 8px",
                fontSize: 11,
                borderRadius: 4,
                background: block.style === s.value ? t.accentSoft : "transparent",
                color: block.style === s.value ? t.accent : t.text3,
                border: `1px solid ${block.style === s.value ? t.accentStrong : t.border}`,
                cursor: "pointer",
              }}
            >
              {s.label}
            </button>
          ))}
        </div>
      )}
      <Divider style={block.style} />
    </div>
  );
}

function Divider({ style }: { style: DividerBlock["style"] }) {
  if (style === "line") {
    return (
      <div
        style={{
          height: 1,
          background: t.borderStrong,
          margin: "16px 0",
        }}
      />
    );
  }
  if (style === "dots") {
    return (
      <div
        style={{
          textAlign: "center",
          margin: "16px 0",
          letterSpacing: "0.5em",
          fontSize: 16,
          color: t.text3,
        }}
      >
        • • •
      </div>
    );
  }
  if (style === "asterisks") {
    return (
      <div
        style={{
          textAlign: "center",
          margin: "16px 0",
          letterSpacing: "0.5em",
          fontSize: 16,
          color: t.text3,
          fontFamily: t.serif,
        }}
      >
        ✻ ✻ ✻
      </div>
    );
  }
  // blank
  return <div style={{ height: 48 }} />;
}
